module.exports = __webpack_public_path__ + "img/card-text.4f3a97b1.svg";